var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.modals),function(item,i){return _c(item.component,{key:i,tag:"component",attrs:{"params":item},on:{"hide":_vm.hide}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }